import React from 'react'
import Field from '../common/Field'
import i18n from 'i18n'

interface DataRow {
  optical_sample_count?: number
  avg_reflectance?: number
}

interface StructuredDataObject {
  data_rows?: DataRow[]
}

interface SensorKitPPGDetailsProps {
  data?: {
    structured_data_objects?: StructuredDataObject[]
  }
}

const formatNumber = (val: unknown, decimals: number = 2): string => {
  if (val === undefined || val === null) return 'N/A'
  if (typeof val === 'number') return Number.isFinite(val) ? val.toFixed(decimals) : 'N/A'
  if (typeof val === 'string') {
    const num = parseFloat(val)
    return Number.isNaN(num) ? val : num.toFixed(decimals)
  }
  return String(val)
}

const SensorKitPPGDetails: React.FC<SensorKitPPGDetailsProps> = (props) => {
  const sdos: StructuredDataObject[] = props?.data?.structured_data_objects ?? []
  if (sdos.length === 0) return <></>

  const dataRows: DataRow[] = sdos[0]?.data_rows ?? []

  let totalOpticalCount = 0
  let weightedReflectanceSum = 0

  dataRows.forEach((row) => {
    const count = row.optical_sample_count ?? 0
    totalOpticalCount += count
    weightedReflectanceSum += (row.avg_reflectance ?? 0) * count
  })

  const avgReflectance = totalOpticalCount > 0
    ? weightedReflectanceSum / totalOpticalCount
    : undefined

  return (
    <div className='sport-fields'>
      <Field key='optical_count' title={i18n.t('components.sensor_kit.ppg.optical_count', { defaultValue: 'Optical Sample Count' })} value={formatNumber(totalOpticalCount, 0)} />
      <Field key='avg_reflectance' title={i18n.t('components.sensor_kit.ppg.avg_reflectance', { defaultValue: 'Avg Reflectance' })} value={formatNumber(avgReflectance)} />
    </div>
  )
}

export default SensorKitPPGDetails
